// Polyfill: expose Buffer as a global for legacy code that reads window.Buffer.
// This file is loaded first in the webpack entry bundle.
import { Buffer } from 'buffer';
window.Buffer = Buffer;
